import { createContext } from 'react';

export type ShowGalleryPictureModalContextProps = {
  closeModal: () => void
  openModal: (pictures: File[]) => void
  pictures: File[]
  isOpen: boolean
}

export const ShowGalleryPictureModalContext = createContext<ShowGalleryPictureModalContextProps | null>(null)